import "./Main.css";
import React from "react";
import { t } from "i18next";

export default function AboutUs() {
  const items = [
    {
      title: t("who we are title"),
      text: t("who we are p"),
    },
    {
      title: t("how we work title"),
      text: t("how we work p"),
    },
    {
      title: t("our motivation title"),
      text: t("our motivation p"),
    },
  ];

  return (
    <section className="skyua-main-section" id="who-we-are">
      <div className="skyua-main-container">
        <div className="skyua-main-heading">
          <span className="skyua-main-eyebrow">{t("about us title")}</span>
          <h2>
            {t("home about heading") !== "home about heading"
              ? t("home about heading")
              : "Фонд, який перетворює допомогу на системні рішення"}
          </h2>
        </div>

        <div className="skyua-about-home-grid">
          {items.map((item, index) => (
            <article className="skyua-about-home-card" key={item.title}>
              <span className="skyua-card-index">
                {String(index + 1).padStart(2, "0")}
              </span>

              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
